import { render, staticRenderFns } from "./groupIntroduce.vue?vue&type=template&id=225adbae&scoped=true"
import script from "./groupIntroduce.vue?vue&type=script&lang=js"
export * from "./groupIntroduce.vue?vue&type=script&lang=js"
import style0 from "./groupIntroduce.vue?vue&type=style&index=0&id=225adbae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225adbae",
  null
  
)

export default component.exports